<template>
  <directus-image class="z-10 w-8 cursor-pointer" />
</template>
<script setup lang="ts">
import DirectusImage from './DirectusImage.vue';
</script>
